import {
  GET_LOGS,
  GET_TOTAL_LOGS,
  CLEAR_LOGS,
} from '../constants/actionTypes';

const initialState = {
  logs: null,
  total: 0,
};

const logs = (state = initialState, action) => {
  switch (action.type) {
    case GET_LOGS:
      return {...state, logs: action.payload};
    case GET_TOTAL_LOGS:
      return {...state, total: action.payload};
    case CLEAR_LOGS:
      return initialState;
    default:
      return state;
  }
}

export default logs;



// WEBPACK FOOTER //
// ./src/reducers/reducer-logs.js